import { BasicTab } from "./BaseTab";

export const RoadmapTab = () => {
  return (
    <BasicTab title="Roadmap" tooltip="View Roadmap">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden"
        }}
      >
        <p
          style={{
            margin: 0,
            padding: 0,
            width: "100%",
            fontSize: "13px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            userSelect: "none"
          }}
        >
          Roadmap
        </p>
      </div>
    </BasicTab>
  );
};
